import React from "react";
import MultiSelectDropdown from "./base/MultiSelectDropdown";

const SelectUserSituations = ({ selectedUserSituations, setSelectedUserSituations, enableInapt = false, title = "app.report.userStatus", displayEmpty }) => {
  const userStatusReport = [
    { value: "NEW", label: "app.report.status.newUser" },
    { value: "INACTIVE", label: "app.report.status.inactive" },
    { value: "ACTIVE", label: "app.report.status.active" },
    ...(enableInapt ? [{ value: "INAPT", label: "app.report.status.inapt" }] : []),
  ];

  return (
    <MultiSelectDropdown
      title={title}
      values={userStatusReport}
      onChange={setSelectedUserSituations}
    />
  );
};

export default React.memo(SelectUserSituations);
